<template>
    <div class="login pa-0">
        <v-row style="height: 100%">
            <v-col class="pa-16 text-center d-inline-flex justify-center align-center" cols="12" md="6">
                <div class="px-md-16" >
                    <h2 class="primary--text pt-6 pa-0">Inicio de sesión</h2>
                    <v-subheader style="display: block !important" class="text-center">Complete los campos para iniciar sesión</v-subheader>
                    <form @submit.prevent=doLogin>
                        <v-text-field
                            v-model="email"
                            label="Correo"
                            append-icon="mdi-email"
                            type="email"
                            hide-details
                            outlined
                            class="pt-3"
                        ></v-text-field>
                        <v-text-field
                            v-model="password"
                            label="Contraseña"
                            :append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
                            :type="showPass ? 'text' : 'password'"
                            @click:append="showPass = !showPass"
                            hide-details
                            outlined
                            class="pt-3"
                        >
                        </v-text-field>
                        <v-alert type="warning" dense class="mt-3" v-if="error.show">
                            {{ error.message }}
                        </v-alert>
                        <v-btn 
                            color="accent" 
                            @click.prevent="doLogin" 
                            block
                            class="mt-6 mb-3"
                            type="submit"
                            >Iniciar sesión</v-btn
                        >
                        <router-link to="sendemail">
                            <a 
                                class="text-body-2 primary--text">
                                Recuperar contraseña
                            </a>
                        </router-link>
                    </form>
                </div>
            </v-col>
            <v-col class="pa-0" cols="12" md="6">
                <v-img
                    dark
                    height="100vh"
                    class="image-login d-inline-flex align-center"
                    src="@/assets/login-banner.jpeg"
                    gradient="180deg, #1d6842ba 40%, #21726894 100%"
                >
                    <div class="pa-16 text-center">
                    </div>
                </v-img>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
    name: 'Login',
    data() {
        return {
            email: '',
            password: '',
            showPass: false,
            error: {
                message: '',
                show: false
            }
        }
    },
    methods: {
        ...mapActions({ login: 'user/login' }),
        async doLogin() {
            try {
                if(!this.email || !this.password){
                    this.error.message = 'El correo y contraseña son requeridos'
                    this.error.show = true
                    return
                }
                await this.login({
                    email: this.email,
                    password: this.password,
                })
                this.$router.push({ name: 'Home' })
            } catch (error) {
                this.error.message = 'El correo o la contraseña son invalidos'
                this.error.show = true
            }
        },
    },
}
</script>

<style scoped>
.login {
    height: 100%;
}
.card {
    overflow: hidden !important;
}
.image-login {
    min-height: 30px;
}
</style>
